export default __webpack_public_path__ + "static/media/close.73f32829.svg";